<template>
	<div class="portalCms-column">
		<div class="portalCms-column-header">
			<sw-button type="primary" size="small" @click="$router.push({ name: 'AddColumn' })">
				<sw-icon icon="add" />
				添加
			</sw-button>
			<!-- <sw-button plain size="small" @click="deleteColumn">
				<sw-icon icon="trash" />
				删除
			</sw-button> -->
			<div style="flex: 1"></div>
			<sw-search :placeholder="'栏目名称'" @search="searchHandle"></sw-search>
		</div>
		<div class="portalCms-column-content">
			<sw-table
				:tableName="'column-list'"
				:tableData="tableData"
				:tableTitle="tableTitle"
				:tableOperation="tableOperation"
				:totalCount="tableLength"
				:pageSizes="[10, 50, 100]"
				row-key="id"
				noPagination
				default-expand-all
				@selection-change="selectionChange"
				@operation-handle="operationHandle"
			></sw-table>
		</div>
	</div>
</template>

<script>
import { getColumnList, deleteColumnList } from '@/api/cms-api';
export default {
	data() {
		return {
			rootId: '000',
			tableData: [],
			tableLength: 0,
			tableTitle: [
				{
					prop: 'columnName',
					label: '栏目名称',
					width: '120',
					sortable: false
				},
				{
					prop: 'columnCode',
					label: '栏目代码',
					width: '120',
					sortable: false
				}
			],
			tableOperation: [
				{
					name: '编辑',
					icon: 'su-icon-edit',
					operation: 'edit',
					className: 'testgreen'
				},
				{ name: '删除', icon: 'su-icon-delete', operation: 'delete' }
			],
			tableSelect: [],
			searchColumn: ''
		};
	},
	created() {
		this.handleColumnList()
	},
	methods: {
		// dragHandle(oldIndex, newIndex, val) {
		// 	console.log('参数' + oldIndex + ',' + newIndex + ',' + val);
		// },
		deleteColumn() {
			console.log('dddd')
		},
		deleteColumnList(data) {
			deleteColumnList(data).then(res => {
				if (res.code === 0) {
					this.$message({
						message: '删除成功～',
						type: 'success'
					});
					this.handleColumnList();
				} else {
					this.$message.error('删除失败');
				}
			});
		},
		handleColumnList() {
			let data = {
				columnName: this.searchColumn
			};
			getColumnList(data).then(res => {
				let data = res.data || [];
				console.log(data)
				this.tableLength = data.length;
				this.tableData = data;
			});
		},
		searchHandle(val) {
			this.searchColumn = val;
			this.handleColumnList();
		},
		selectionChange(data) {
			this.tableSelect = data;
		},
		operationHandle(id, operation) {
			if (this[`${operation}Handle`]) {
				this[`${operation}Handle`](id);
			}
		},
		deleteHandle(id) {
			const data = {
				columnId: [id]
			};
			this.confirmDialoag('确认删除栏目吗？', () => this.deleteColumnList(data));
		},
		editHandle(value) {
			console.log(value);
			this.$router.push({ name: 'AddColumn', params: { colId: value } });
		},
		confirmDialoag(confirmText, confirmFn, cancelFn) {
			this.$confirm(confirmText)
				.then(() => {
					confirmFn && confirmFn();
				})
				.catch(() => {
					cancelFn && cancelFn();
				});
		}
	}
};
</script>

<style lang="scss">
.portalCms-column {
	padding: 16px 20px 0;
	&-header {
		display: flex;
		justify-content: space-between;
		margin-bottom: 16px;
		.sw-button {
			font-size: 14px;
			margin: 0 8px 0 0;
			.sw-icon {
				font-size: 16px;
				margin-right: 3px;
			}
		}
		.el-row {
			width: 320px;
		}
	}
}
</style>